const noOp = (..._args: unknown[]) => void 0;

const consoleInstance = typeof console !== "undefined" ? console : undefined;

export const safeConsole: Pick<Console, "trace" | "warn" | "table"> = {
  trace: (consoleInstance?.trace ?? noOp).bind(consoleInstance),
  warn: (consoleInstance?.warn ?? noOp).bind(consoleInstance),
  table: (consoleInstance?.table ?? noOp).bind(consoleInstance),
};
